import { kongApi } from 'packages/common/helpers/api';

const payrollApi = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PAYROLL}/`,
});

const payrollPersonApi = kongApi({
  baseURL: `${process.env.VUE_APP_BASE_URL_PAYROLL_PERSON}/`,
});

export default {
  generatePayment(params) {
    return payrollApi.post('self-employed-payments/', params);
  },
  generateReport(params) {
    return payrollApi.post('reports', params, {
      responseType: 'blob',
    });
  },
  getPayments(competence, page) {
    return payrollApi.get(`self-employed-payments?page=${page}&competence=${competence}`);
  },
  getPaymentById(id) {
    return payrollApi.get(`self-employed-payments/${id}`);
  },
  deletePayment(paymentId) {
    return payrollApi.delete(`self-employed-payments/${paymentId}`);
  },
  getSelfEmployedList({ page, size = 10 }) {
    return payrollPersonApi.get('v1/self-employeds', {
      params: {
        page,
        size,
      },
    });
  },
  getSelfEmployed(selfEmployedId) {
    return payrollPersonApi.get(`v1/self-employeds/${selfEmployedId}`);
  },
  deleteSelfEmployed(selfEmployedId) {
    return payrollPersonApi.delete(`v1/self-employeds/${selfEmployedId}`);
  },
  createNewSelfEmployed(params) {
    return payrollPersonApi.post('v1/self-employeds', { ...params });
  },
  editSelfEmployed(selfEmployedId, params) {
    return payrollPersonApi.put(`v1/self-employeds/${selfEmployedId}`, { ...params });
  },
};
